<template>
  <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
    <vx-card no-shadow class="custom-min-height">
      <vs-list>
        <vs-list-item title="คำนวนดอกเบี้ยรายวัน">
          <vs-button type="line" line-origin="left" color="success" @click="callDailyCalculators()">เรียกฟั่งชั่น</vs-button>
        </vs-list-item>
        <vs-list-item title="สร้างผู้ใช้งานใหม่">
          <vs-button type="line" line-origin="left" color="success" @click="callDailyCreateUserStudent()">เรียกฟั่งชั่น</vs-button>
        </vs-list-item>
        <vs-list-item title="คัดลอกข้อมูลผู้กู้ไปยังผู้ค้ำประกัน">
          <vs-button type="line" line-origin="left" color="success" @click="callCreateSuretiesByBorrower()">เรียกฟั่งชั่น</vs-button>
        </vs-list-item>
        <vs-list-item title="อัพเดทข้อมูลหลักสูตร (ภายนอก)">
          <vs-button type="line" line-origin="left" color="success" @click="callUpdateCurriculumExternalApi()">เรียกฟั่งชั่น</vs-button>
        </vs-list-item>
        <vs-list-item title="เรียกดูข้อมูลสัญญาที่ยังไม่ได้อัพเดท">
          <vs-button type="line" line-origin="left" color="success" @click="callGetContractTransactionNotUpdate()">เรียกฟั่งชั่น</vs-button>
        </vs-list-item>
      </vs-list>
    </vx-card>
  </div>
</template>

<script>
import {confirmCode} from "@/constants/config";
import {createNamespacedHelpers} from "vuex";

const { mapActions: mapSystemActions, mapState: mapSystemState } = createNamespacedHelpers('System')

export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapSystemState(['status', 'maintenances']),
  },
  methods: {
    ...mapSystemActions([
      'initializing',
      'getContractTransactionNotUpdate',
      'initializing',
      'dailyCalculators',
      'dailyCreateUserStudent',
      'getMaintenances',
      'updateMaintenances',
      'getConfig',
      'getConfigSigner',
      'updateConfig',
      'updateConfigSigner'
    ]),
    async callDailyCalculators(){
      const vm = this
      const { dailyCalculators } = vm
      const inputCode = prompt("กรุณากรอกรหัสยืนยัน เพื่อยืนยันการดำเนินการ", "");
      if (confirmCode === inputCode) {
        vm.$vs.loading()
        await dailyCalculators()
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async callDailyCreateUserStudent(){
      const vm = this
      const { dailyCreateUserStudent } = vm
      const inputCode = prompt("กรุณากรอกรหัสยืนยัน เพื่อยืนยันการดำเนินการ", "");
      if (confirmCode === inputCode) {
        vm.$vs.loading()
        await dailyCreateUserStudent()
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async callCreateSuretiesByBorrower(){
      const vm = this
      const { createSuretiesByBorrower } = vm
      const inputCode = prompt("กรุณากรอกรหัสยืนยัน เพื่อยืนยันการดำเนินการ", "");
      if (confirmCode === inputCode) {
        vm.$vs.loading()
        await createSuretiesByBorrower()
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async callUpdateCurriculumExternalApi(){
      const vm = this
      const { updateCurriculumExternalApi } = vm
      const inputCode = prompt("กรุณากรอกรหัสยืนยัน เพื่อยืนยันการดำเนินการ", "");
      if (confirmCode === inputCode) {
        vm.$vs.loading()
        await updateCurriculumExternalApi();
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async callGetContractTransactionNotUpdate(){
      const vm = this
      const { getContractTransactionNotUpdate } = vm
      const inputCode = prompt("กรุณากรอกรหัสยืนยัน เพื่อยืนยันการดำเนินการ", "");
      if (confirmCode === inputCode) {
        vm.$vs.loading()
        await getContractTransactionNotUpdate()
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async initDate() {

    }
  },
  async created () {
    await this.initDate()
  },
};
</script>

<style scoped>
.custom-min-height {
  min-height: 500px; /* Set your desired minimum height */
}
.position-bottom-right {
  align-self: flex-end;
  margin: 16px; /* Adjust the margin as needed */
}
</style>
